import { render, staticRenderFns } from "./KeyAccess.vue?vue&type=template&id=c547f03c&"
import script from "./KeyAccess.vue?vue&type=script&lang=ts&"
export * from "./KeyAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports